/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerRatingMatch = {
    properties: {
        match: {
            type: 'MatchSmall',
            isRequired: true,
        },
        rating: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        manOfTheMatch: {
            type: 'boolean',
            isRequired: true,
        },
        amountYellowCards: {
            type: 'number',
            isRequired: true,
        },
        amountRedCards: {
            type: 'number',
            isRequired: true,
        },
        amountGoals: {
            type: 'number',
            isRequired: true,
        },
        amountOwnGoals: {
            type: 'number',
            isRequired: true,
        },
        amountMinutesPlayed: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
